<template>
  <centered-box>
    <h3 class="title is-3">{{ $t("Sign up") }}</h3>
    <message v-if="error" class="is-danger"> {{ $t(error) }} </message>
    <input-field
      type="text"
      :label="$t('Email')"
      v-model="email"
      @focus="email_onFocus"
      :errors="email_errorsIfTouched"
    />
    <input-field
      type="password"
      :label="$t('Password')"
      v-model="password"
      @focus="password_onFocus"
      :errors="password_errorsIfTouched"
    />
    <input-field
      type="password"
      :label="$t('Confirm password')"
      v-model="passwordConfirm"
      @focus="passwordConfirm_onFocus"
      :errors="passwordConfirm_errorsIfTouched"
    />
    <checkbox-field v-model="gdpr" :errors="gdpr_errorsIfTouched">
      {{ $t("I understand that my data are protected according to") }}
      <a href="https://chefcarte.com/res/doc/gdpr.pdf" target="_blank">
        {{ $t("Privacy Policy") }}
      </a>
    </checkbox-field>
    <button
      class="button is-primary is-fullwidth"
      :disabled="!group_valid"
      @click="signUp"
    >
      {{ $t("Sign up") }}
    </button>
    <p class="has-text-centered is-p1">
      <router-link to="/login">{{ $t("All log in options") }}</router-link>
    </p>
  </centered-box>
</template>

<script>
import { actions } from "@/store"
import { InputField, CheckboxField } from "@/components/form"
import { CenteredBox } from "@/components/layout"
import Message from "@/components/message"
import {
  validator,
  email,
  size,
  required,
  customValidation,
  sameAsFn
} from "@/validator"

export default {
  name: "signup",
  mixins: [validator],
  components: {
    InputField,
    CheckboxField,
    CenteredBox,
    Message
  },
  data() {
    return {
      email: undefined,
      password: undefined,
      passwordConfirm: undefined,
      gdpr: undefined,
      error: undefined
    }
  },
  validations: {
    email: [required, email],
    password: [required, size(6, 32)],
    passwordConfirm: [
      required,
      size(6, 32),
      sameAsFn(function() {
        return this.password
      }, "Password")
    ],
    gdpr: [
      customValidation(function() {
        if (this.gdpr !== true) {
          return "You must agree with GDPR."
        }
      })
    ]
  },
  methods: {
    signUp() {
      this.error = undefined
      actions
        .signUpWithEmail(this.email, this.password)
        .then(() => {
          this.$router.push("/manager")
        })
        .catch(error => {
          this.error = this.getErrorMessage(error)
          this.$logger.error(this.error, error)
        })
    },
    getErrorMessage(error) {
      if (error.code === "auth/email-already-in-use") {
        return "email-already-in-use"
      }
      return "signup-error"
    }
  }
}
</script>
